import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  Select,
  message,
  Tooltip,
  Button,
  Cascader,
} from "antd";
import Search from "antd/es/input/Search";
import { useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  PrinterOutlined,
  SearchOutlined,
  SaveOutlined,
  FilterOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_CANCEL_LIST,
  POST_NEW_LOAN,
  POST_TERMINATE_CONTRACT_RECORD,
} from "../../API/apiUrls";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { cancelCodeOptions } from "./constant/CancelCodeOption";
import { getSchemaContractOptions } from "./constant/SchemaOption";
import ThaiDatePicker from "../../../hook/ThaiDatePicker";
import { ExportExcelForUpdatePostNumber } from "./export/ExportExcelForUpdatePostNumber";
import AddBarcode from "./modal/AddBarcode";
import { useNavigate } from "react-router-dom";

const Main = ({ onClick }) => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const contractOptions = getSchemaContractOptions(userCompany);
  const [loading, setLoading] = useState(false);
  const [arrData, setArrData] = useState([]);
  const [arrayTable, setArrayTable] = useState([]);
  const [forPaySelect, setForPaySelect] = useState();
  const [selectedGCode, setSelectedGCode] = useState();
  const [datePicker, setDatePicker] = useState();
  const [selectedContract, setSelectedContract] = useState();
  const [rawData, setRawData] = useState();
  const [rawDataSend, setRawDataSend] = useState([]);
  const [cancelCodeSelect, setCancelCodeSelect] = useState([]);
  const [isModalAddBarcode, setIsModalAddBarcode] = useState(false);
  const [dataAddBarcode, setDataAddBarCode] = useState();
  const navigate = useNavigate();

  const handleMenuClick = () => {
    if (onClick) onClick("บอกเลิกสัญญา");
    // ทำการย้อนกลับ
    navigate(-1);
  };

  const onCascaderChange = (value, selectedOptions) => {
    console.log("value", value);
    setCancelCodeSelect(value);
    const [forPay, gcode] = value || [];
    setForPaySelect(forPay);
    setSelectedGCode(gcode);
  };

  const handleLoad = () => {
    console.log("load");
    if (selectedContract?.value && datePicker) {
      setForPaySelect(null);
      setSelectedGCode(null);
      setCancelCodeSelect([]);
      setRawData([]);
      setRawDataSend([]);
      loadData();
    } else {
      message.error("กรุณาเลือกสัญญาและวันที่ !! ");
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const payload = {
        date1: datePicker.format("YYYY-MM-DD"),
        date2: datePicker.format("YYYY-MM-DD"),
        DATA_TYPE: selectedContract.value,
      };

      const { data, status } = await axios.post(
        POST_TERMINATE_CONTRACT_RECORD,
        payload,
        { headers: HEADERS_EXPORT_BEN }
      );

      if (
        status !== 200 ||
        !data ||
        (Array.isArray(data) && data.length === 0)
      ) {
        setArrayTable([]);
        setArrData([]);
        message.warning("ไม่มีข้อมูล");
        return;
      }

      console.log("res data", data);
      filterData(data);
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error("API error:", status, serverMsg || error.message);

      setArrayTable([]);
      setArrData([]);
      message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (value) => {
    if (Array.isArray(value)) {
      let filteredDataCompany;

      if (userCompany === "3") {
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return true;
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.contractNo.includes("UD")
          );
        });
      } else {
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false;
          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }
      // dataContractUse = บช.ภายในตัดหนี้ 0
      let dataContractUse = filteredDataCompany.filter(
        (item) =>
          item.CONTNO?.substring(0, 1) !== "5" &&
          item.CONTNO?.substring(0, 1) !== "6" &&
          item.CONTNO?.substring(0, 1) !== "7"
      );
      setRawData(dataContractUse);
      console.log("dataContractUse", dataContractUse);

      let customData = mergeDataWithGuarantors(dataContractUse);

      setArrData(customData);
      setArrayTable(customData);
      setLoading(false);
    }
  };

  const mergeDataWithGuarantors = (data) => {
    console.log("mergeDataWithGuarantors");
    let mergedData;
    if (selectedContract.value !== "lsfhp") {
      mergedData = data.reduce((acc, record) => {
        const mainData = (record.address || []).map((addr) => ({
          ...record,
          cusType: 0,
          GCODE: record.GCODE,
          REGNO: record.REGNO,
          CONTNO: record.CONTNO, // เพิ่ม CONTNO ให้ชัดเจน
          NAME: `${record.SNAM} ${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim(),
          address: addr,
        }));

        const guarantorData = (record.guarantors || []).flatMap((guarantor) =>
          (guarantor.address || []).map((addr) => ({
            ...record,
            cusType: parseInt(guarantor.GARNO),
            NAME: `${guarantor.SNAM} ${guarantor.NAME1} ${guarantor.NAME2}`.trim(),
            address: addr,
          }))
        );

        return [...acc, ...mainData, ...guarantorData];
      }, []);
    } else {
      mergedData = data.reduce((acc, record) => {
        const mainData = (record.address || []).map((addr) => ({
          ...record,
          cusType: 0,
          GCODE: record.GCODE,
          REGNO: record.REGNO,
          CONTNO: record.CONTNO, // เพิ่ม CONTNO ให้ชัดเจน
          NAME: `${record.SNAM} ${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim(),
          address: addr,
        }));
        return [...acc, ...mainData];
      }, []);
    }

    // เรียงลำดับ CONTNO ก่อน แล้ว GARNO ทีหลัง
    const sortedData = mergedData.sort((a, b) => {
      const contnoComparison = a.DOCNO.localeCompare(b.DOCNO, undefined, {
        numeric: true,
      });
      if (contnoComparison !== 0) return contnoComparison; // เรียงตาม CONTNO ก่อน

      return (a.cusType || 0) - (b.cusType || 0); // GARNO: 0 (ลูกค้าหลัก) จะมาก่อน, จากนั้นเรียง 1, 2, 3...
    });

    // เพิ่ม key ให้แต่ละ record เริ่มจาก 1
    return sortedData.map((item, index) => ({
      ...item,
      key: index + 1, // เริ่ม key จาก 1
    }));
  };

  const handlefilterData = () => {
    setLoading(true);
    let dataFilter;
    let rawDataFilter;
    console.log("arrData", arrData);

    if (!forPaySelect || !selectedGCode) {
      setArrayTable(arrData);
      setRawDataSend([]);
      setTimeout(() => {
        setLoading(false);
      }, 250);
      return;
    }

    if (forPaySelect === "116") {
      console.log("if");
      dataFilter = arrData.filter(
        (item) =>
          (forPaySelect === item.FORCODE || item.FORCODE === "115") &&
          selectedGCode === item.GCODE &&
          item.cusType > 0
      );

      rawDataFilter = rawData.filter(
        (item) =>
          (forPaySelect === item.FORCODE || item.FORCODE === "115") &&
          selectedGCode === item.GCODE
      );
    } else {
      console.log("else");
      dataFilter = arrData.filter(
        (item) => forPaySelect === item.FORCODE && selectedGCode === item.GCODE
      );
      rawDataFilter = rawData.filter(
        (item) => forPaySelect === item.FORCODE && selectedGCode === item.GCODE
      );
    }
    console.log("dataFilter--->", dataFilter);
    console.log("rawDataFilter", rawDataFilter);

    if (dataFilter?.length === 0) {
      message.error("ไม่พบข้อมูล");
    }

    let sortFilter = dataFilter.map((item, index) => ({
      ...item,
      key: index + 1, // เริ่ม key จาก 1
    }));
    setArrayTable(sortFilter);
    setRawDataSend(rawDataFilter);

    setTimeout(() => {
      setLoading(false);
    }, 250);
  };

  const onSearch = (value) => {
    setLoading(true);
    let result;

    if (value) {
      result = arrData.filter(
        (item) =>
          (item.CONTNO && item.CONTNO.includes(value.trim())) ||
          (item.NAME && item.NAME.includes(value.trim())) ||
          (item.NAME1 && item.NAME1.includes(value.trim())) ||
          (item.NAME2 && item.NAME2.includes(value.trim())) ||
          (item.REGNO && item.REGNO.includes(value.trim()))
      );
    } else {
      result = arrData;
      setCancelCodeSelect([]);
      setRawDataSend([]);
    }

    setTimeout(() => {
      setLoading(false);
    }, 250);
    setRawDataSend([]);
    setArrayTable(result);
  };

  const insertData = async () => {
    if (
      !rawDataSend ||
      (Array.isArray(rawDataSend) && rawDataSend.length === 0)
    ) {
      message.error("ไม่มีข้อมูลที่บันทึก");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `${BASE_URL_BEN}${POST_NEW_LOAN}`,
        rawDataSend,
        { headers: HEADERS_EXPORT_BEN }
      );

      const { status, data } = res;

      if (status === 200) {
        message.success("สร้างข้อมูลใหม่สำเร็จ");
      } else if (status === 201) {
        message.warning(String(data?.OK));
      } else {
        message.success(`สำเร็จ (รหัส ${status})`);
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message;

      if (status === 404) {
        message.error("ไม่พบปลายทาง (404)");
      } else {
        message.error(
          `ไม่สามารถส่งข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
        );
      }
      console.error("insertData error:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadDataExport = async (status) => {
    if (!rawDataSend || rawDataSend.length === 0) {
      message.error("ไม่พบข้อมูล");
      return;
    }
    if (!selectedContract) {
      message.error("กรุณาเลือกประเภทสัญญา");
      return;
    }

    const dataForExport = Array.from(
      new Set((rawDataSend || []).map((item) => item?.DOCNO).filter(Boolean))
    );

    setLoading(true);
    try {
      const { data } = await axios.post(
        `${BASE_URL_BEN}${POST_CANCEL_LIST}`,
        {
          DATA_TYPE: selectedContract?.value,
          DOCNO: dataForExport,
        },
        { headers: HEADERS_EXPORT_BEN }
      );

      if (data === "ไม่พบข้อมูล") {
        message.error("โปรดบันทึกข้อมูลก่อน");
        return;
      }
      if (data === "ส่งค่ามาไม่ถูก") {
        message.error("ไม่มีข้อมูล");
        return;
      }
      console.log("1------>", data);
      if (status === "export") {
        ExportExcelForUpdatePostNumber(data, selectedGCode, selectedContract);
        message.success("โหลด Excel สำเร็จ");
      } else {
        let i = 1;
        const newData = data.map((item) => ({
          ...item,
          key: i++,
        }));

        setDataAddBarCode(newData);
        setIsModalAddBarcode(true);
      }
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message || error.message;
      console.error("loadDataExport error:", status, serverMsg);
      message.error(
        `ไม่สามารถพิมพ์ข้อมูลได้${status ? ` (${status})` : ""}: ${serverMsg}`
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "key", // ใช้ key แทน dataIndex เพราะเราไม่ต้องการใช้ข้อมูลจาก data
      align: "center",
      render: (text, record, index) => (
        <>{record.key}</> // ใช้ index ที่ถูกส่งมาจาก Table เพื่อเพิ่มลำดับแถว
      ),
    },
    {
      title: "วันที่ออกจดหมาย",
      align: "center",
      render: (record) => (
        <>
          {record.DOCDT
            ? dayjs(record.DOCDT).add(543, "year").format("D MMM YY")
            : null}
        </>
      ),
    },
    {
      title: "ประเภท",
      dataIndex: "GCODE",
      key: "GCODE",
      align: "center",
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER",
      key: "CUSTOMER",
      align: "center",
      render: (text, record) => <>{record.NAME ? record.NAME : null}</>,
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",
      render: (text, record) => (
        <>
          {record.cusType === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำที่ ${record.cusType}`}
        </>
      ),
    },
    {
      title: "รายละเอียดรถ",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <>
          {record.TYPE} <br />
          {record.REGNO}
        </>
      ),
    },
    {
      title: "ค้างงวด",
      dataIndex: "EXP_PRD",
      key: "EXP_PRD",
      align: "center",
      // render: (text, record) => (
      //   <>{record.LOAN.CONTNO ? record.LOAN.CONTNO : null}</>
      // ),
    },
    {
      title: "เงินค้าง",
      align: "center",
      render: (text, record) => (
        <>
          {currencyFormatPoint(record.TOTPRC - record.SMPAY)} <br />
        </>
      ),
    },
    {
      title: "ค่าทวงถาม",
      align: "center",
      render: (text, record) => <>{currencyFormatComma(record.LETTER)}</>,
    },
  ];

  return (
    <>
      {/* <Button
        type="primary"
        ghost
        icon={<RollbackOutlined />}
        onClick={handleMenuClick}
        style={{ marginBottom: 5 }}
      >
        ย้อนกลับ
      </Button> */}
      <Card>
        <Row>
          <Col span={"12"} style={{ textAlign: "start" }}>
            <Select
              key={userCompany}
              size="large"
              style={{ minWidth: "auto", marginRight: 8 }}
              placeholder="เลือกสัญญา"
              popupMatchSelectWidth={false}
              labelInValue // ★ เปิดใช้
              value={selectedContract} // ต้องเป็น object { value, label }
              onChange={(obj) => setSelectedContract(obj ?? null)} // obj = { value, label }
              options={contractOptions}
              allowClear
              showSearch
              optionFilterProp="label"
            />
            <Space size={16}>
              <ThaiDatePicker
                value={datePicker}
                onChange={setDatePicker}
                size="large"
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={handleLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "end", marginTop: "5px" }}>
            <Cascader
              value={cancelCodeSelect}
              options={cancelCodeOptions}
              onChange={onCascaderChange}
              placeholder="เลือกประเภทข้อมูล"
              allowClear
              showSearch
              size="large"
              style={{
                width: "auto",
                marginRight: "5px",
              }}
            />

            <Button
              type="default"
              icon={<FilterOutlined />}
              size="large"
              style={{
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                fontWeight: "bold",
                backgroundColor: "#fff7d6",
                color: "#333",
                border: "1px solid #ffe58f",
              }}
              onClick={handlefilterData}
              disabled={loading}
            >
              กรองข้อมูล
            </Button>
          </Col>
          <Col span={12} style={{ marginTop: "5px" }}>
            <Space size={10}>
              <Tooltip
                placement="bottom"
                title={
                  rawDataSend.length > 0 ? null : "โปรดเลือกประเภทข้อมูลก่อน !"
                }
                disabled={true}
              >
                <Button
                  type="primary"
                  icon={
                    <SaveOutlined
                      style={{
                        fontSize: "24px",
                        color: "white",
                      }}
                    />
                  }
                  onClick={insertData}
                  disabled={rawDataSend.length === 0 || loading}
                  style={{
                    marginRight: "10px",
                  }}
                >
                  บันทึก
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title="บันทึกข้อมูล Excel">
                <Button
                  type="text"
                  icon={
                    <PrinterOutlined
                      style={{
                        fontSize: "24px",
                        color: rawDataSend.length === 0 ? "grey" : "green",
                      }}
                    />
                  }
                  onClick={() => loadDataExport("export")}
                  disabled={rawDataSend.length === 0 || loading}
                  style={{
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                    padding: "10px",
                  }}
                  loading={loading}
                >
                  Excel
                </Button>
              </Tooltip>
              <Button
                type="text"
                onClick={() => loadDataExport("barcode")}
                disabled={rawDataSend.length === 0 || loading}
                style={{
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  padding: "10px",
                }}
                loading={loading}
              >
                🧾 ยิง Barcode
              </Button>
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "end" }}>
            <Space size={16} style={{ marginTop: "10px" }}>
              <Search
                placeholder="ค้นหาสัญญา"
                enterButton
                onSearch={onSearch}
                style={{
                  width: "auto",
                  borderRadius: "8px",
                }}
                size="large"
              />
            </Space>
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"}>
              <Table
                style={{ marginTop: "10px" }}
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => (
                  <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable.length} </p>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalAddBarcode ? (
        <AddBarcode
          open={isModalAddBarcode}
          close={setIsModalAddBarcode}
          data={dataAddBarcode}
          typePay={selectedGCode}
          typeContract={selectedContract}
        />
      ) : null}
    </>
  );
};

const CreateCancelContract = MotionHoc(Main);
export default CreateCancelContract;
